import React, { useState, useRef, useEffect } from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import './ColumnHoverButton.css';

interface ColumnHoverButtonProps {
  onEnrichRows: (rowCount: number | 'all') => void;
  isVisible: boolean;
  columnName: string;
}

const ColumnHoverButton: React.FC<ColumnHoverButtonProps> = ({ 
  onEnrichRows, 
  isVisible, 
  columnName 
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);

  const enrichOptions = [
    { label: 'First row', value: 1 },
    { label: 'First 10 rows', value: 10 },
    { label: 'First 100 rows', value: 100 },
    { label: 'All empty rows', value: 'all' as const }
  ];

  const handleOptionClick = (value: number | 'all') => {
    onEnrichRows(value);
    setIsMenuOpen(false);
  };

  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  if (!isVisible) return null;

  return (
    <div className="column-hover-button-container" ref={buttonRef}>
      <button
        className="column-hover-button"
        onClick={handleButtonClick}
        title={`Enrich ${columnName} column`}
      >
        <PlayArrowIcon style={{ fontSize: '14px' }} />
        <KeyboardArrowDownIcon style={{ fontSize: '12px' }} />
      </button>
      
      {isMenuOpen && (
        <div className="column-hover-menu">
          {enrichOptions.map((option) => (
            <button
              key={option.label}
              className="column-hover-menu-item"
              onClick={() => handleOptionClick(option.value)}
              type="button"
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ColumnHoverButton; 